<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "MiniGame",
};
</script>

<style></style>
